import { toast } from "react-toastify";
function successToast(message, duration = 3000) {
    toast.success(message, {
        position: "top-right",
        autoClose: duration
    })
}
function errorToast(message, duration = 3000) {
    toast.error(message, {
        position: "top-right",
        autoClose: duration
    })
}
export function copyToClipboard(str) {
    navigator.clipboard.writeText(str);
    successToast("Copied", 2000);
}
const individualColorsname = {"Free Listing" : "black","Marketer": "#f05ef0","Senior Marketer" : "#8b04ee", "Team Leader" : "#5656f7", "Team Manager" : "lightgreen","Unit Leader":"yellow","Unit Manager":"orange","Unit Head":"red"}
const companyColorsname = {"Free Listing" : "black","Marketer": "darkviolet","Senior Marketer" : "indigo", "Team Leader" : "blue", "Team Manager" : "green","Unit Leader":"#c7c700","Unit Manager":"#d48900","Unit Head":"#b70000"}
const individualColors = {"0" : "black","1": "#f05ef0","2" : "#8b04ee", "3" : "#5656f7", "4" : "lightgreen","5":"yellow","6":"orange","7":"red"}
const companyColors = {"0" : "black","1": "darkviolet","2" : "indigo", "3" : "blue", "4" : "green","5":"#c7c700","6":"#d48900","7":"#b70000"}
const ranknames = {"0":"Free Listing","1" : "Marketer","2":"Senior Marketer","3":"Team Leader","4":"Team Manager","5" : "Unit Leader","6":"Unit Manager","7":"Unit Head"}
export {
    successToast, errorToast, individualColors,companyColors, ranknames, individualColorsname, companyColorsname
}